import React from "react"
import { IconProps } from "@/types/icon"

/**
 * Heart icon for wishlist functionality.
 * Can be filled or outlined based on the `filled` prop.
 */
const Heart: React.FC<IconProps & { filled?: boolean }> = ({
  size = "16",
  color = "currentColor",
  filled = false,
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? color : "none"}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...attributes}
    >
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  )
}

export default Heart

















